<script lang="ts">
	import type { Thing, WithContext } from "schema-dts";

	type ObjectThing = Extract<Thing, object>;
	const { data }: { data: ObjectThing | WithContext<ObjectThing> } = $props();
	const json = $derived({
		"@context": "https://schema.org",
		...data,
	});
</script>

<svelte:head>
	<svelte:element this={"script"} type="application/ld+json">
		{JSON.stringify(json)}
	</svelte:element>
</svelte:head>
